import { render, staticRenderFns } from "./CardBorder.vue?vue&type=template&id=1af84814&"
import script from "./CardBorder.vue?vue&type=script&lang=js&"
export * from "./CardBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports